import React, { Component } from 'react';
import '../../css/pages/home.css';
import { toast } from 'react-toastify';
import moment from 'moment';
import SideNav from '../components/SideNav';
import Pagination from '../components/Pagination';
import TopNav from '../components/TopNav';
import AxiosClient from '../utils/AxiosClient';
import { fetchAgents } from '../actions/account';

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payments: [],
      fromdate: '',
      todate: '',
      query: '',
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
      loading: '',
      status: 'payments',
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSearchRecord = (page = 1, search = '', sortBy = 'created_on', sortDir = 'DESC', limit = 10) => {
    const {
      agent, fromdate, todate, status, amount,
    } = this.state;

    this.setState({ processing: 'Processing', transactions: [] }, async () => {
      try {
        const client = await AxiosClient();
        const response = await client.get(`business/report/search?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=users.first_name,users.last_name,users.phone_number,users.email&lenderid=${agent}&fromdate=${fromdate}&todate=${todate}&status=${status}&amount=${amount}`);

        this.setState({ payments: response.data.data.loans });

        if (response.data.status !== 'success') throw new Error(response?.data.message);
      } catch (error) {
        toast.error(
          error.response?.data?.message
          || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.',
        );
      } finally {
        this.setState({ processing: false });
      }
    });
  };

  render() {
    const { processing, payments } = this.state;
    return (
      <>
        <SideNav page="payments" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="payments" />
            <section className="body-main__content">
              <div className="home">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Hello,&nbsp;</h3>
                  <p className="pageTitle__subheader">Welcome back!</p>
                </div>
               
                <div className="row" style={{ marginTop: '20' }}>
                  <div className="col-12 col-xl-4">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      name="fromdate"
                      onChange={this.handleOnChange}
                      className="form-control" />
                    <br />
                  </div>
                  <div className="col-12 col-xl-4">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      name="todate"
                      onChange={this.handleOnChange}
                      className="form-control" />
                  </div>
                  <div className="col-12 col-xl-4">
                    <div style={{ marginTop: '30px' }}>
                      <button
                        type="button"
                        onClick={() => this.handleSearchRecord()}
                        className="btn btn-primary"
                        disabled={processing}>
                        {processing ? 'Processing...' : 'Search'}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="row my-4">
                      <div className="col-12">
                        <div className="default-card page-table">
                          <div className="table-responsive">
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <th className="reference">Borrower</th>
                                  <th className="reference">Phone Number</th>
                                  <th className="amount">Loan Amount</th>
                                  <th className="amount">Paid</th>
                                  <th className="amount">Balance</th>
                                  <th className="amount">Date Paid</th>
                                  <th className="narration">Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                {payments.map((rec) => (
                                  <tr key={rec.id}>
                                    <td className="text-nowrap">{rec.borrower}</td>
                                    <td className="text-nowrap">{rec.phone_number}</td>
                                    <td className="text-nowrap">{Number(rec?.loan_amount).toLocaleString()}</td>
                                    <td className="text-nowrap">{Number(rec?.amount_attempted).toLocaleString()}</td>
                                    <td className="text-nowrap">{Number(rec?.balance).toLocaleString()}</td>
                                    <td className="text-nowrap">{rec.created_on}</td>
                                    <td className="text-nowrap">{rec.meta}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default Report;
